import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-124b2d9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalJira",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "imgBack" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        viewBox: "0 0 32 32",
        height: "32",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
      }, [
        /*#__PURE__*/_createElementVNode("defs", null, [
          /*#__PURE__*/_createElementVNode("linearGradient", {
            x1: "108.695%",
            x2: "12.439%",
            y1: "-14.936%",
            y2: "45.215%",
            id: "uid49-1"
          }, [
            /*#__PURE__*/_createElementVNode("stop", {
              "stop-color": "#0052CC",
              offset: "0%"
            }),
            /*#__PURE__*/_createElementVNode("stop", {
              "stop-color": "#2684FF",
              offset: "100%"
            })
          ]),
          /*#__PURE__*/_createElementVNode("linearGradient", {
            x1: "0%",
            x2: "91.029%",
            y1: "118.55%",
            y2: "63.971%",
            id: "uid49-2"
          }, [
            /*#__PURE__*/_createElementVNode("stop", {
              "stop-color": "#0052CC",
              offset: "0%"
            }),
            /*#__PURE__*/_createElementVNode("stop", {
              "stop-color": "#2684FF",
              offset: "100%"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("g", {
          stroke: "none",
          "stroke-width": "1",
          "fill-rule": "nonzero"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            fill: "#2684FF",
            d: "M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            fill: "url(#uid49-1",
            d: "M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            fill: "url(#uid49-2",
            d: "M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z"
          })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "modal-title",
        id: "exampleModalLongTitle"
      }, " Adicionar ticket a sprint no JIRA "),
      /*#__PURE__*/_createElementVNode("p", null, "Escolha o projeto e o tipo de issue")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body p-8 d-flex flex-column gap-2",
  style: {"background-color":"#e6e6e6"},
  id: "modalBody"
}
const _hoisted_7 = { class: "d-flex flex-column gap-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Escolha o projeto", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Escolha o projeto", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "d-flex flex-column gap-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo issue", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer p-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-sm btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancelar"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-sm btn-light-danger",
    "data-bs-dismiss": "modal"
  }, "Salvar")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projDefined) = $event)),
                class: "p-2 rounded-1 border-0"
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (proj, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: proj.key
                  }, _toDisplayString(proj.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.projDefined]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_select, {
                modelValue: _ctx.typeDefined,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeDefined) = $event)),
                placeholder: "Escolha a issue",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.projDefined !== 'SGSI' && _ctx.projDefined !== 'II')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.issues, (tipo, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          value: tipo
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tipo), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: "Tarefa"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tarefa")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _hoisted_13
        ])
      ])
    ])
  ]))
}